import { render, staticRenderFns } from "./FormSubmitted.vue?vue&type=template&id=8d942eea&scoped=true"
import script from "./FormSubmitted.vue?vue&type=script&lang=js"
export * from "./FormSubmitted.vue?vue&type=script&lang=js"
import style0 from "./FormSubmitted.vue?vue&type=style&index=0&id=8d942eea&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d942eea",
  null
  
)

export default component.exports